import './modules/eapps-instagram-feed'
import './modules/footer-newsletter'
import './modules/yotpo'

import './sections/main-collection'

const isHoverCapable = () => {
  return window.matchMedia('(hover: hover)').matches
}

document.body.classList.add(isHoverCapable() ? 'hover-capable' : 'non-hover')

window.addEventListener('resize', () => {
  if (isHoverCapable()) {
    document.body.classList.remove('non-hover')
    document.body.classList.add('hover-capable')
  } else {
    document.body.classList.remove('hover-capable')
    document.body.classList.add('non-hover')
  }
})
